import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectOffice,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchOffice,
  selectLocation,
  addLocation,
  fetchLocationMaster,
} from "./locationManagementSlice";
import {
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { select } from "redux-saga/effects";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  selectParameter,
} from "../businessParameter/businessParameterSlice";
import { fetchCountryAll } from "../location/locationSlice";
import { LocationManagementTable } from "./LocationManagementTable";
import { FormHelperText } from "@material-ui/core";
import { ModalAreaSelect } from "./ModalAreaSelect";
import { ModalParentSelect } from "./ModalParentSelect";
import { ModalAreaTypeFilter } from "./ModalAreaTypeFilter";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const LocationManagementPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectLocation);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const forceUpdate = useForceUpdate();
  const paginationSet = useSelector(selectPagination);
  const dataDistance = useSelector(selectParameter);

  // Filter
  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);
  const [active, setActive] = useState("");
  const [locationAddress, setLocationAddress] = useState("");
  const [parentAddress, setParentAddress] = useState("");
  const [areaType, setAreaType] = useState("");

  // initial

  const [formValues, setFormValues] = useState({
    name: {
      value: "",
      error: false,
      required: "Y",
    },
    length: {
      value: "",
      error: false,
      required: "N",
    },
    width: {
      value: "",
      error: false,
      required: "N",
    },
    distance: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const [formArea, setFormArea] = useState({
    name: {
      value: "",
      error: false,
      required: "Y",
    },
    area_type: {
      value: "",
      error: false,
      required: "N",
    },
    area_type_name: {
      value: "",
      error: false,
      required: "N",
    },
    parent_area: {
      value: "",
      error: false,
      required: "Y",
    },
    parent_area_name: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(
        fetchLocationMaster({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );

      await dispatch(
        fetchParameter({
          paramgroup_code: "DISTANCE_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setForce(false);
    }
  }, [force]);

  const handleSearch = async () => {
    let params = {
      location_name: locationAddress,
      parent_name: parentAddress,
      area_type_name: areaType,
    };

    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchLocationMaster(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        location_name: locationAddress,
        parent_name: parentAddress,
        area_type_name: areaType,
      };
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchLocationMaster(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }
    if (
      formValues.name.value.includes("<script>") ||
      formValues.name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    const params = {
      location_name: formValues.name.value,
      length: formValues.length.value,
      width: formValues.width.value,
      measurement: formValues.distance.value,
      type: "motor_pool",
    };

    console.log(params, "params");

    try {
      const response = await dispatch(addLocation(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await history.push(
            `/motor-pool/location-management/motor-pool/${response.payload.data.data.location_id}`
          );
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // Func Create
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormValues({
      name: {
        value: "",
        error: false,
        required: "Y",
      },
      length: {
        value: "",
        error: false,
        required: "N",
      },
      width: {
        value: "",
        error: false,
        required: "N",
      },
      distance: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const distanceOptions = dataDistance.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });
  const handleChangeDistance = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["distance"]: {
        ...formValues["distance"],
        value,
      },
    });
  };

  // area

  // Func Create
  const [showAreaCreate, setShowAreaCreate] = useState(false);

  const handleCloseAreaCreate = () => {
    setFormArea({
      name: {
        value: "",
        error: false,
        required: "Y",
      },
      area_type: {
        value: "",
        error: false,
        required: "N",
      },
      area_type_name: {
        value: "",
        error: false,
        required: "N",
      },
      parent_area: {
        value: "",
        error: false,
        required: "Y",
      },
      parent_area_name: {
        value: "",
        error: false,
        required: "Y",
      },
    });
    setShowAreaCreate(false);
  };
  const handleShowAreaCreate = () => setShowAreaCreate(true);
  const handleChangeArea = (e) => {
    const { name, value } = e.target;
    setFormArea({
      ...formArea,
      [name]: {
        ...formArea[name],
        value,
      },
    });
  };

  const validatePostArea = (e) => {
    let isValid = true;

    const formFields = Object.keys(formArea);
    let newFormValues = { ...formArea };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formArea[currentField].value;
      const required = formArea[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormArea(newFormValues);

    return isValid;
  };

  const handleSaveArea = async () => {
    if (!validatePostArea()) {
      return;
    }

    const params = {
      pid: formArea.parent_area.value,
      location_name: formArea.name.value,
      area_type: formArea.area_type.value,
      type: "area",
    };

    console.log(params, "params");

    try {
      const response = await dispatch(addLocation(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await history.push(
            `/motor-pool/location-management/area/${response.payload.data.data.location_id}`
          );
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [showParent, setShowParent] = useState(false);
  const [showArea, setShowArea] = useState(false);
  const [showAreaFilter, setShowAreaFilter] = useState(false);
  const [fieldsParent, setFieldsParent] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);
  const [fieldsArea, setFieldsArea] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <ThemeProvider theme={formLabelsTheme}>
        <div>
          <Card>
            <CardBody>
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    {" "}
                    <RedditTextField
                      label="Location Address"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="Location Address"
                      onChange={(e) => setLocationAddress(e.target.value)}
                      value={locationAddress}
                    />
                    <RedditTextField
                      label="Parent Address"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="Parent Address"
                      onChange={(e) => setParentAddress(e.target.value)}
                      value={parentAddress}
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Area type"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="area_type"
                          readOnly
                          value={areaType}
                        />
                      </Col>
                      <Col>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowAreaFilter(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-6 justify-content-end">
                  <Button variant="primary" onClick={handleSearch}>
                    Search
                  </Button>
                </Row>
              </div>

              <ButtonToolbar>
                <Button
                  active={active === "Motor Pool"}
                  onClick={() => {
                    setShow(true);
                    setActive("Motor Pool");
                  }}
                  variant="outline-primary"
                  className="m-2 "
                >
                  Create Motor Pool Area
                </Button>

                <Button
                  active={active === "Area"}
                  onClick={() => {
                    setShowAreaCreate(true);
                    setActive("Area");
                  }}
                  variant="outline-primary"
                  className="m-2 "
                >
                  Create Area
                </Button>
              </ButtonToolbar>

              <LocationManagementTable
                data={data === null ? [] : data}
                page={pageNo}
                sizePerPage={pageSize}
                totalSize={totalRecord}
                onTableChange={handleTableChange}
                loading={loading}
                handleSearch={handleSearch}
              />
            </CardBody>
          </Card>

          {/* Modal Create */}
        </div>

        {/* Modal Create */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Create New Motor Pool Area
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="Name"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="name"
                    value={formValues.name.value}
                    onChange={handleChange}
                    error={formValues.name.error}
                    helperText={
                      formValues.name.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                </Col>
              </Row>

              <div className="border-r">
                <p className="text-muted">Size</p>
                <Row>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <RedditTextField
                      label="Length"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="length"
                      value={formValues.length.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <p className="font-weight-boldest ml-4 mt-7">X</p>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <RedditTextField
                      label="Width"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="width"
                      value={formValues.width.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <Select
                      options={distanceOptions}
                      value={getValueType(
                        formValues.distance.value,
                        distanceOptions
                      )}
                      onChange={handleChangeDistance}
                      className="mt-4 ml-3"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal Area */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showAreaCreate}
          onHide={handleCloseAreaCreate}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Create New Area
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          required
                          label="Parent Area"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="parent_area"
                          readOnly
                          value={formArea.parent_area_name.value}
                          error={formArea.parent_area.error}
                          helperText={
                            formArea.parent_area.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => setShowParent(true)}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                    </Row>
                    <RedditTextField
                      required
                      label="Motor pool Area"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="product_length"
                      value={data.length > 0 ? data[0].motor_pool_name : ""}
                      disabled
                    />
                  </Col>

                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="name"
                      value={formArea.name.value}
                      onChange={handleChangeArea}
                      error={formArea.name.error}
                      helperText={
                        formArea.name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Area type"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="area_type"
                          readOnly
                          value={formArea.area_type_name.value}
                          error={formArea.area_type.error}
                          helperText={
                            formArea.area_type.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowArea(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseAreaCreate}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSaveArea}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <ModalAreaSelect
          isOpen={showArea}
          setShow={setShowArea}
          setFormValues={setFormArea}
          formValues={formArea}
          setFields={setFieldsArea}
          fields={fieldsArea}
        />
        <ModalAreaTypeFilter
          isOpen={showAreaFilter}
          setShow={setShowAreaFilter}
          areaType={areaType}
          setAreaType={setAreaType}
          setFields={setFieldsArea}
          fields={fieldsArea}
        />

        <ModalParentSelect
          isOpen={showParent}
          setShow={setShowParent}
          setFormValues={setFormArea}
          formValues={formArea}
          setFields={setFieldsParent}
          fields={fieldsParent}
        />
      </ThemeProvider>
    </>
  );
};
